/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import Loader from '@dc/ui-library/src/organisms/Loader/Loader';
import urljoin from 'url-join';

import formatPrice from '@dc/ui-library/src/helpers/formatPrice';
import Rating from '@dc/ui-library/src/molecules/Rating/Rating';
import { SaveForLater } from '../SaveForLater/SaveForLater';
import ImageCarousel from '../ImageCarousel/ImageCarousel';

function getProductPageUrl(mainProductPageUrl, productId) {
  return mainProductPageUrl.replace(/(-([^-]*?)-pdt\.html)/, `-${productId}-pdt.html`);
}
export default class GiftGuideItem extends PureComponent {
  constructor(props) {
    super(props);
    
    this.state = {
      open: false,
      isLoggedIn: false,
      swatches: [],
      swatchesToDisplay: []
    };

    window.appState.subscribe((_) => {
      const appState = window.appState.getState();
      const isLoggedIn = !!(
        appState &&
        appState.userDetails &&
        appState.userDetails.email
      );
      if (this.state.isLoggedIn !== isLoggedIn) {
        this.setState((state) => ({
          ...state,
          isLoggedIn: isLoggedIn
        }));
      }
    });
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  onOpenModal(e) {
    if (this.props.fetchFailed) {
      window.location.href = this.props.item.productPageUrl;
    }
    window.appState.dispatch({
      type: 'EVENTS_CHAT_INTERACTION', // simply push new event
      payload: {
        eventName: 'GiftGuide Interaction - Modal opened',
        eventAction: 'GiftGuide',
        trackFunctionArgs: 'GiftGuide Interaction'
      }
    });
    if (!this.state.swatchesLoaded) {
      this.loadSwatches(this.props.item.productId);
    }
    if (e.target.localName !== 'path' && e.target.localName !== 'button') {
      this.setState({ open: true });
    }
  }

  onCloseModal() {
    this.setState({ open: false });
  }

  loadSwatches(productID) {
    const allowedSwatchTypes = Object.keys(this.props.displayedSwatchTypes);
    fetch(
      urljoin(this.props.storeApiUrl, '/products/', productID, '/swatches'),
      { credentials: 'include' }
    )
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) =>
        this.setState((state) => ({
          ...state,
          swatches: data.payload,
          swatchesLoaded: true,
          swatchesFailed: false,
          swatchesToDisplay: data.payload.filter(
            (swatchType) => allowedSwatchTypes.includes(swatchType.property)
          )
        })))
      .catch((_) =>
        this.setState((state) => ({
          ...state,
          swatches: [],
          swatchesLoaded: false,
          swatchesFailed: true
        })));
  }

  formatSwatchImageUrl(name, productVariantValue) {
    const variant = productVariantValue.replace(/[^\w]/g, '-').toLowerCase();
    const category = name.replace(/_/gi, '-').toLowerCase();

    const imgIcon = category;
    let imgName;

    if (name === 'colour') {
      imgName = `s-${variant}.jpg`;
    } else if (name === 'media_type') {
      imgName = `-${variant}.png`;
    } else {
      imgName = '.png';
    }

    return urljoin(
      this.props.cdnUrl,
      `/css/themes/${category}-swatch/Search-${imgIcon}-icon${imgName}`
    );
  }

  renderModal(productTitle, product, item, productInfo) {
    return (
      <Modal
        classNames={{ modal: 'productModal' }}
        open={this.state.open}
        onClose={this.onCloseModal}
        center
        blockScroll
      >
        <div className={'productModalBody'} id={this.props.giftGuideID}>
          <h2 className={'pr-name'}>{productTitle}</h2>
          <p className={'pr-code'}>
            {this.props.texts.productCode}
            {' '}
            {product.sku}
            {' '}
          </p>
          <div className={'pr-images'}>
            <ImageCarousel images={product.images} />
          </div>

          <div className={'pr-info'}>
            
            <div className={'pr-info-block'}>
              {this.props.showCustomerRating && (
                <div>
                  <h3>{this.props.texts.customerRating}</h3>
                  <Rating
                    maxCount={5}
                    ratingCount={product.customerReview.number}
                    ratingValue={product.customerReview.averageScore}
                  />
                </div>
              )}
              {product.mainFeatures.length > 0 && (
                <div>
                  <h3 style={{ marginTop: this.props.showCustomerRating ? '1em' : '0' }}>
                    {this.props.texts.mainFeatures}
                  </h3>
                  <ul className={'pr-features'}>
                    {product.mainFeatures.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {
              this.state.swatches.length === 0 &&
              !this.state.swatchesFailed &&
              !this.state.swatchesLoaded &&
                <Loader />
            }
            {this.state.swatchesToDisplay.length > 0 && (
              <div className={'pr-swatches-block'}>
                <h3>Similar models in this range</h3>
                <div className={'pr-swatches'}>
                  {this.state.swatchesToDisplay.map((swatchType) => (
                    <div key={swatchType.property}>
                      <p>
                        {this.props.displayedSwatchTypes[swatchType.property]}
                        :
                      </p>
                      <ul>
                        {swatchType.products.map((swatch) => (
                          <li className={'dc-product-swatch'} key={swatch.product.id}>
                            <a
                              href={getProductPageUrl(item.productPageUrl, swatch.product.id)}
                              target={this.props.linkTarget}
                              className={'dc-product-swatch-link'}
                            >
                              <img
                                alt={swatch.propertyValue}
                                src={this.formatSwatchImageUrl(swatchType.property,
                                  swatch.propertyValue)}
                                className={'dc-product-swatch-image'}
                              />
                              <span className={'dc-product-swatch-value'}>
                                {swatch.propertyValue}
                              </span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className={'pr-price-block'}>
              <div className={'pr-price'}>
                {formatPrice(product.price.amount, true, product.price.currencyCode)}
                { product &&
                  !this.props.hideSavePrice &&
                  product.price.discountAmount > 0 && (
                  <div className={'pr-saveprice'}>
                    {this.props.texts.save}
                    {' '}
                    {
                      formatPrice(
                        product.price.discountAmount, true, product.price.currencyCode
                      )
                    }
                  </div>
                )}
              </div>
              <div className={'pr-actions'}>
                <a
                  data-interaction={'gift-guide-product'}
                  href={item.productPageUrl}
                  target={this.props.linkTarget}
                  className={'btn green-btn'}
                >
                  {this.props.texts.moreInfo}
                </a>
                {product &&
                  (this.props.showSfl || (this.state.isLoggedIn && this.props.showSflLogged)) && (
                  <SaveForLater
                    userLoggedIn={this.state.isLoggedIn}
                    {...productInfo}
                    productInfo={productInfo}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    const { item, product, classes } = this.props;
    const productTitle = item.guideTitle ||
      (product ? `${product.brand.label} ${product.label}` : '&nbsp;');
    const productInfo = product ? {
      productId: product.id,
      name: productTitle,
      image: product.images[0].url,
      price: formatPrice(product.price.amount, true, product.price.currencyCode),
      rating: product.customerReview.averageScore,
      ratingCount: product.customerReview.number
    } : {};
    return item ? (
      <>
        <article className={`item ${classes}`} key={`${item.productId}`}>
          <img
            src={item.image || productInfo.image}
            alt={item.productId}
            onClick={this.onOpenModal}
          />
          {product &&
            (this.props.showSfl || (this.state.isLoggedIn && this.props.showSflLogged)) && (
            <SaveForLater
              userLoggedIn={this.state.isLoggedIn}
              {...productInfo}
              productInfo={productInfo}
            />
          )}
          <div className={'pr-info'} onClick={this.onOpenModal}>
            <h3>{productTitle}</h3>
            <h2>
              {product &&
              formatPrice(product.price.amount, true, product.price.currencyCode)}
            </h2>
          </div>
        </article>
        {product && this.renderModal(productTitle, product, item, productInfo)}
      </>
    ) : '';
  }
}

// TODO: add missing proptypes
GiftGuideItem.propTypes = {
  item: PropTypes.shape({
    productId: PropTypes.string.isRequired,
    productPageUrl: PropTypes.string.isRequired
  }).isRequired,
  product: PropTypes.shape({
    mainFeatures: PropTypes.arrayOf(PropTypes.string),
    availableSwatches: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  classes: PropTypes.string,
  displayedSwatchTypes: PropTypes.arrayOf(PropTypes.string),
  giftGuideID: PropTypes.string.isRequired,
  storeApiUrl: PropTypes.string.isRequired,
  cdnUrl: PropTypes.string.isRequired,
  fetchFailed: PropTypes.bool,
  linkTarget: PropTypes.string,
  showCustomerRating: PropTypes.bool,
  showSfl: PropTypes.bool,
  showSflLogged: PropTypes.bool,
  hideSavePrice: PropTypes.bool,
  texts: PropTypes.shape({
    customerRating: PropTypes.string.isRequired,
    mainFeatures: PropTypes.string.isRequired,
    moreInfo: PropTypes.string.isRequired,
    productCode: PropTypes.string.isRequired,
    save: PropTypes.string.isRequired
  })
};

GiftGuideItem.defaultProps = {
  classes: '',
  displayedSwatchTypes: [],
  product: null,
  fetchFailed: false,
  linkTarget: '_blank',
  showCustomerRating: false,
  showSfl: false,
  showSflLogged: false,
  hideSavePrice: false,
  texts: {
    customerRating: 'Customer rating:',
    mainFeatures: 'Main Features:',
    moreInfo: 'More info',
    productCode: 'Product code:',
    save: 'Save'
  }
};
